import React, { useState, useEffect } from "react";
import { API } from "../App";
import { Box, TextField, Alert, Avatar, Typography } from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";

function AdminLoginComponent() {
  const [loading, setLoading] = useState(false);
  const validateToken = async (token) => {
    const valid = await fetch(`${API}/api/admin/users/list`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then((res) => {
      if (res.status === 400 || res.status === 401) {
        return false;
      }
      return true;
    });
    if (valid) {
      return (window.location.href = "/admin/panel/1");
    } else {
      setLoading(false);
    }
  };
  useEffect(() => {
    setLoading(true);
    validateToken(localStorage.getItem("tk"));
  }, []);
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = new FormData(e.currentTarget);
    const body = {
      email: data.get("email"),
      password: data.get("password"),
    };

    const response = await fetch(`${API}/api/admin/auth/signin`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    })
      .then((res) => res.json())
      .catch((err) => console.log(err));

    if (response.token) {
      localStorage.setItem("tk", response.token);
      setMessage("Sesión iniciada con éxito!");
      window.location.href = "/admin/panel/1";
    } else {
      setError("Las credenciales ingresadas son incorrectas");
    }
  };

  return (
    <>
      {/* <CssBaseline /> */}
      {!loading && (
        <Box
          sx={{
            marginTop: 8,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography style={{ color: "white" }} component="h1" variant="h5">
            Ingresar
          </Typography>
          <Box
            component="form"
            onSubmit={handleSubmit}
            noValidate
            sx={{ mt: 1 }}
          >
            <TextField
              className="adminlogin__inputField"
              margin="normal"
              required
              fullWidth
              id="email"
              label="Email"
              name="email"
              autoComplete="email"
              autoFocus
            />
            <TextField
              className="adminlogin__inputField"
              margin="normal"
              required
              fullWidth
              name="password"
              label="Contraseña"
              type="password"
              id="password"
              autoComplete="current-password"
            />

            <button type="submit" className="adminlogin__submitBtn">
              Ingresar
            </button>
            {message ? (
              <Alert severity="success">{message}</Alert>
            ) : (
              error && <Alert severity="error">{error}</Alert>
            )}
          </Box>
        </Box>
      )}
    </>
  );
}

export default AdminLoginComponent;
